/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/DataSource/PermissionsPivotDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { SubjectPermissions } from "TFS/Admin/Common/Contracts/OrganizationSettings";

const PermissionsMetadataProviderId = "ms.vss-admin-web.org-admin-groups-permissions-pivot-data-provider";

export function getPermissions(pageContext: IVssPageContext, subjectDescriptor: string): Promise<SubjectPermissions | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService
        .getDataAsync<SubjectPermissions>(PermissionsMetadataProviderId, { subjectDescriptor: subjectDescriptor }, true)
        .then(result => {
            return result;
        });
}
